import { MapEditorState } from "./MapEditorContext.types";
import { useMapEditorActions } from "./useMapEditorActions";
import { useMapEditorProps } from "./useMapEditorProps";
import { useMapEditorSelection } from "./useMapEditorSelection";
import { useMapEditorTool } from "./useMapEditorTool";
import { useMapEditorUI } from "./useMapEditorUI";

export const useMapEditor = (): MapEditorState => {
  const actions = useMapEditorActions();
  const selection = useMapEditorSelection();
  const tool = useMapEditorTool();
  const ui = useMapEditorUI();
  const props = useMapEditorProps();
  return { ...actions, ...selection, ...tool, ...ui, ...props };
};
